import axios from "common/configs/axiosConfigs";
import React, { useState } from "react";
import logo from "assets/img/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { storeAuth } from "store/slices/authSlice";
import { toast } from "react-toastify";

const Signup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [values, setValues] = useState({});
  const [isPassAccurate, setIsPassAccurate] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isPassAccurate) {
      try {
        const { data } = await axios.post("", {
          action: "register",
          accountType: 1,
          ...values,
        });
        if (data.success) {
          dispatch(storeAuth(data?.user));
          navigate("/login");
          toast.success("You registered successfully");
        } else {
          toast.error(data?.error);
        }
      } catch (err) {
        console.error("ERROR:", err);
      }
    } else {
      toast.error("Confirm password couldn't match");
    }
  };
  const handleInput = ({ target: { value, name } }) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <section className="login-section p-0">
      <div className="container">
        <img src={logo} alt="logo" style={{ width: 70, display: "block", margin: "0 auto 20px" }} />
        <div className="card signup-box mx-auto">
          <h3 className="text-center">Sign up</h3>
          <p className="text-muted text-center">Create your account</p>
          <form onSubmit={handleSubmit}>
            <div className="row gy-3">
              <div className="col-12">
                <label>
                  {/* <span>Name</span> */}
                  <input
                    type="text"
                    name="name"
                    onChange={handleInput}
                    className="form-control"
                    placeholder="Your name"
                    required
                  />
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  {/* <span>Phone</span> */}
                  <input
                    type="tell"
                    name="phone"
                    pattern="[0-9]{10}"
                    onChange={handleInput}
                    className="form-control"
                    placeholder="Phone number"
                    required
                  />
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  {/* <span>Email</span> */}
                  <input
                    type="email"
                    name="email"
                    onChange={handleInput}
                    className="form-control"
                    placeholder="Email Address"
                    required
                  />
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  {/* <span>Password</span> */}
                  <input
                    type="password"
                    name="password"
                    onChange={handleInput}
                    className="form-control"
                    placeholder="Password"
                    required
                  />
                </label>
              </div>
              <div className="col-lg-6">
                <label>
                  {/* <span>Confirm Password</span> */}
                  <input
                    type="password"
                    onChange={(e) => setIsPassAccurate(e.target.value === values.password)}
                    className="form-control"
                    placeholder="Confirm password"
                    required
                  />
                </label>
              </div>
            </div>

            <button type="submit" className="btn btn-primary mt-3 w-100">
              Sign Up
            </button>
          </form>

          <p className="my-3 text-center">
            Already have an account?{" "}
            <Link to="/login" className="text-primary text-decoration-underline">
              Login now
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Signup;
